import { MessageFormatConfig } from 'ngx-translate-messageformat-compiler';

import { dateFormatter } from '../formatters/date.formatter';
import { numberFormatter } from '../formatters/number.formatter';

export function messageFormatConfigFactory(): MessageFormatConfig {
  return {
    formatters: {
      fmtDate: dateFormatter(),
      fmtNumber: numberFormatter(),
    }
  };
}
